// 点击事件
export const commonClickFn = (item, specialData, _this, moduleName) => {
    let {
        openModel,
        selectType,
        selectUrlType,
        freedomPageUrl,
        systemPageUrl,
        linkUrl,
        id,
        fileId,
        articleId,
        fileType,
        urlType,
        videoUrl,
        url,
        classId,
        classDesc
    } = item;

    let { showContentType, showReadFlag, showPublishFlag } = specialData;
    if((moduleName || showContentType == 1)
        &&(fileType == 2||selectType==2)){ // 视频情况
        _this.$router.push({
            path: '/newcms/video',
            query: {
                entryUrl: videoUrl || url,
                fileId:fileId
            }
        })
        return
    }
    if (showContentType == 2) { // 直接调取情况
        if (item.enclosureType == 1) {
            if((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)){
                window.location.href = item.enclosureUrl; // 路由跳转需要结构出
            }else {
                window.open(item.enclosureUrl);
            }
            return;
        }
        _this.$router.push({
            path: "/newcms/detail",
            query: {
                articleId: id? id: articleId,
                showReadFlag: !moduleName?showReadFlag? 0 : 1 : '',
                showPublishFlag: !moduleName?showPublishFlag? 0 : 1 : ''
            },
        });
        return;
    }
    if (!selectUrlType) return;
    let skipUrl = "";
    
    if(!articleId || [6, 7, 8, 9].includes(selectUrlType)){
        if (openModel != 1&&!(window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)) {
            var newTab=window.open('about:blank');
        }
        // 自由设置情况下出现的跳转情况
        switch (selectUrlType) {
            case 2:
                skipUrl = freedomPageUrl;
                break;
            case 3:
                skipUrl = systemPageUrl;
                break;
            case 4:
                if (urlType == 1) {
                    skipUrl = _this.$router.resolve({
                        path: linkUrl,
                        query: {
                            articleId: articleId,
                        },
                    });
                } else {
                    skipUrl = linkUrl;
                }
                break;
            case 5:
                skipUrl = _this.$router.resolve({
                    path: "/newcms/list",
                    query: {
                        classId: classId,
                    },
                });
                break;
            case 6:
              skipUrl = _this.$router.resolve({
                path: "/goodsDetail",
                query: {
                  goodsId: articleId,
                  goodsKind: 1
                }
              });
              break;
            case 7:
              skipUrl = _this.$router.resolve({
                path: "/goodsList"
              });
              break;
            case 8:
              skipUrl = _this.$router.resolve({
                path: "/entityGoodsDetail",
                query: {
                  goodsId: articleId,
                  goodsKind: 3
                }
              });
              break;
            case 9:
              skipUrl = _this.$router.resolve({
                path: "/entityGoodsList",
                query: {
                  branchId: localStorage.getItem('branchId')
                }
              });
              break;
            case 10:
              skipUrl = _this.$router.resolve({
                path: "/goodsDetail",
                query: {
                  goodsId: articleId,
                  goodsKind: 2
                }
              });
              break;
            case 11:
              skipUrl = _this.$router.resolve({
                path: "/distributionGoodsList",
                query: {
                  categoryId: classId,
                  categoryCode: classDesc,
                  isH5: 1
                }
              });
              break;
        }
        let routerUrl = typeof skipUrl == "object" ? skipUrl.href : skipUrl;
        console.log(routerUrl,'1------------')
        if((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)){
            console.log('微信浏览器打开',routerUrl)
            window.location.href = routerUrl; // 路由跳转需要结构出
            return;
        }
        if (openModel == 1) { // 当前页面打开
            console.log(routerUrl,'99999999999')
            window.location.href = routerUrl; // 路由跳转需要结构出href
            return;
        }
        newTab.location.href=routerUrl;

    }else {

        // if (!(window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)) {
        //     var newTabs=window.open('about:blank');
        // }
        _this.$apis.cms.getArticleDetail({ articleId: articleId,
            pageSize: 999,
            pageNum: 1}).then(res=>{
            // 请求接口   判断文章情况下是否存在pdf   enclosureType==1直接打开
            if(res.data.list[0]&&res.data.list[0].enclosureType == 1){
                // if((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)){ //微信
                // console.log('微信浏览器打开',res.data[0].enclosureUrl)
                window.location.href = res.data.list[0].enclosureUrl; // 路由跳转需要结构出
                return;
                // }else {
                //     newTabs.location.href=res.data[0].enclosureUrl;
                //     // window.open(res.data[0].enclosureUrl)
                // }
            }else {
                skipUrl = _this.$router.resolve({
                    path: "/newcms/detail",
                    query: {
                        articleId: articleId,
                        showReadFlag: !moduleName? showReadFlag? 0 : 1 : '',
                        showPublishFlag: !moduleName? showPublishFlag? 0 : 1 : ''
                    },
                });
                window.location.href = skipUrl.href; // 路由跳转需要结构出href
            }
        })
    }

};



// 图文   点击查看更多
export const checkMoreClickFn = (item, specialData, _this, moduleName)=>{
    let {
        openModel,
        selectUrlType,
        freedomPageUrl,
        systemPageUrl,
        linkUrl,
        articleId,
        urlType,
        classId
    } = item;
    
    let {  showReadFlag, showPublishFlag } = specialData;
    if (!selectUrlType) return;
    let skipUrl = "";

    if(!articleId || [6, 7, 8, 9].includes(selectUrlType)){
        if (openModel != 1&&!((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1))) {
            var newTab=window.open('about:blank');
        }
        // 正常设置连接跳转情况下
        switch (selectUrlType) {
            case 2:
                skipUrl = freedomPageUrl;
                break;
            case 3:
                skipUrl = systemPageUrl;
                break;
            case 4:
                if (urlType == 1) {
                    skipUrl = _this.$router.resolve({
                        path: linkUrl
                    });
                } else {
                    skipUrl = linkUrl;
                }
                break;
            case 5:
                skipUrl = _this.$router.resolve({
                    path: "/newcms/list",
                    query: {
                        classId: classId,
                    },
                });
                break;
            case 6:
              skipUrl = _this.$router.resolve({
                path: "/goodsDetail",
                query: {
                  goodsId: articleId,
                  goodsKind: 1
                }
              });
              break;
            case 7:
              skipUrl = _this.$router.resolve({
                path: "/courseGoods"
              });
              break;
            case 8:
              skipUrl = _this.$router.resolve({
                path: "/entityGoodsDetail",
                query: {
                  goodsId: articleId,
                  goodsKind: 3
                }
              });
              break;
            case 9:
              skipUrl = _this.$router.resolve({
                path: "/courseGoods"
              });
              break;
        }
        let routerUrl = typeof skipUrl == "object" ? skipUrl.href : skipUrl;
        console.log(routerUrl,'routerUrlrouterUrlrouterUrlrouterUrlrouterUrl')

        if((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)){
            console.log('微信浏览器打开',routerUrl)
            window.location.href = routerUrl; // 路由跳转需要结构出
            return;
        }
        if (openModel == 1) {
            console.log(routerUrl,'12312312312')
            window.location.href = routerUrl; // 路由跳转需要结构出href
            return;
        }
        // window.open(routerUrl);
        newTab.location.href=routerUrl;
    }else {
        // if (!(window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)) {
        //     var newTabs=window.open('about:blank');
        // }
        _this.$apis.cms.getArticleDetail({ articleId: articleId,
            pageSize: 999,
            pageNum: 1}).then(res=>{
            if(res.data.list[0]&&res.data.list[0].enclosureType == 1){ // 判断文章是否存在pdf
                // if((window.navigator.userAgent.toLowerCase().indexOf('micromessenger')!==-1)){
                //     console.log('微信浏览器打开',res.data[0].enclosureUrl)
                window.location.href = res.data.list[0].enclosureUrl; // 路由跳转需要结构出
                return;
                // }else {
                //     newTabs.location.href=res.data[0].enclosureUrl;
                //     // window.open(res.data[0].enclosureUrl)
                // }
            }else {
                skipUrl = _this.$router.resolve({
                    path: "/newcms/detail",
                    query: {
                        articleId: articleId,
                        showReadFlag: !moduleName? showReadFlag? 0 : 1 : '',
                        showPublishFlag: !moduleName? showPublishFlag? 0 : 1 : ''
                    },
                });
                window.location.href = skipUrl.href; // 路由跳转需要结构出href
            }
        })
    }

}



